export default "__VITE_ASSET__Cj8HzavY__"